export type BankAccountProvider = "PLAID" | "PAYNOTE";

export type BankTransferProvider = BankAccountProvider | "DISABLED";

export const PLAID_ITEM_STATUS_HEALTHY = "HEALTHY";

export interface BankAccount {
  id: string;
  provider: BankAccountProvider;
  bankName: string;
  accountName?: string;
  last4: string;
  type: string;
  isDefault: boolean;
  status: string;
  itemId?: string;
  created_at: string; // ISO 8601 timestamp
}

export interface BankAccountsResponse {
  bank_deposit_provider: BankTransferProvider;
  bank_withdrawal_provider: BankTransferProvider;
  accounts: BankAccount[];
}
